<template>
  <div class="page-commercial-claims">
    <tabbed-view :tabs="getTabs()"></tabbed-view>
  </div>
</template>

<script>

import TabbedView from '@/views/components/tabs/TabbedView';
import {mapGetters} from 'vuex';

export default {
name: "CommercialProduct",
  components: {
    TabbedView,
  },
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  methods: {
    getTabs() {
      return [
        {
          label: 'Claim Notification Details',
          route: 'commercial-claims.view',
        },
      ]
    }
  },
}
</script>

<style scoped>

</style>
